import * as Yup from 'yup';

const schema = Yup.object().shape({
  nome: Yup.string().required('Valor requerido'),
  codigo: Yup.string().required('Valor requerido'),
  potencial_poluidor_id: Yup.number().required('Valor requerido'),
});

export default schema;
